import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  ShipmentPlannerProfileListState,
  ShipmentPlannerProfileListStateModel,
} from './shipment-planner-profile-list.state';
import {
  ShipmentPlannerProfileListInitialState,
  ShipmentPlannerProfileListLoad,
} from './shipment-planner-profile-list.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ListSearchCriteriaFacade } from '../../../list-search-criteria/list-search-criteria.facade';
import { PlannerProfile, PlannerProfileListSearchCriteria } from '../../../../models';
import { ListSearchCriteriaType } from '../../../list-search-criteria';

@Injectable({ providedIn: 'root' })
export class ShipmentPlannerProfileListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<ShipmentPlannerProfileListStateModel> = this.store.select(
    ShipmentPlannerProfileListState.getState,
  );
  items$: Observable<PlannerProfile[]> = this.store.select(ShipmentPlannerProfileListState.getItems);
  loaded$: Observable<boolean> = this.store.select(ShipmentPlannerProfileListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.ShipmentPlannerProfiles)
      .subscribe((searchCriteria: PlannerProfileListSearchCriteria) => {
        this.store.dispatch(new ShipmentPlannerProfileListLoad(searchCriteria));
      });
  }

  loadListForDialog(searchCriteria: PlannerProfileListSearchCriteria): void {
    this.store.dispatch(new ShipmentPlannerProfileListLoad(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentPlannerProfileListInitialState());
  }
}
